module.exports = __webpack_public_path__ + "images/skonhetsvard.1f7573cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/skonhetsvard.jpg
// module id = efe36403
// module chunks = 6 16